import React, { useLayoutEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import PractitionerCameraPreview from './PractitionerCameraPreview';

interface PractitionerCameraPortalProps {
  portalNode: HTMLDivElement | null;
  isEnabled: boolean;
}

interface PractitionerCameraHostProps {
  portalNode: HTMLDivElement | null;
  isActive: boolean;
  isOverlay?: boolean;
}

export const PractitionerCameraPortal = ({ portalNode, isEnabled }: PractitionerCameraPortalProps) => {
  if (!portalNode || !isEnabled) {
    return null;
  }

  return createPortal(<PractitionerCameraPreview />, portalNode);
};

export const PractitionerCameraHost = ({ portalNode, isActive, isOverlay = false }: PractitionerCameraHostProps) => {
  const hostRef = useRef<HTMLDivElement | null>(null);

  useLayoutEffect(() => {
    const hostElement = hostRef.current;
    if (!portalNode || !isActive || !hostElement) {
      return;
    }

    hostElement.appendChild(portalNode);
  }, [isActive, portalNode]);

  return (
    <div
      ref={hostRef}
      style={{
        display: isActive ? 'block' : 'none',
        position: isOverlay ? 'absolute' : 'relative',
        inset: isOverlay ? 0 : undefined,
        width: '100%',
        height: '100%',
        overflow: isOverlay ? 'hidden' : undefined,
        borderRadius: isOverlay ? '0 0 20px 20px' : undefined,
        padding: isOverlay ? '8px' : undefined,
        boxSizing: 'border-box',
      }}
    />
  );
};
